import React, { useEffect, useState } from "react";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { changeShops } from "services/auth/actions"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import dashboardRoutes from "../../routes/dashboard"
import layoutHOC from "HOC/layoutHOC"
import { Header, Error as ErrorBoundary, MetaData } from "../../../../components";
import config from "constants/config";
import useAuthCookies from "hooks/useAuthCookies";
import Sidebar from "./sidebar";
import MobileMenu from "./mobile-menu";
import { useCookies } from "react-cookie";
import { redirectToSubLink } from "../../../../components/subdomainLink";
import { toastAlert } from "@paylixecommerce/shared/components";
import { toggleNav } from "./actions";
import { Dashboard } from "../../screens";
import { getUserSettings } from "services/auth/actions";
import { formData, authApi } from "utils";
import NotFound from "../../../../components/404-2";
import useMobile from "../../../../hooks/useMobile";
import useWindowSize from "../../../../hooks/useWindowSize";


export const createSubscriptionInvoice = data => () => {
    return authApi
        .post(`invoices/subscription/create`, formData(data))
        .then(res => {
            if (res.status === 200) {
                return res;
            } else if (res.status === 401) {
                return res;
            } else {
                throw res;
            }
        })
        .catch(err => {
            throw err;
        });
};


function DashboardLayout({ changeTheme }) {

    const dispatch = useDispatch();
    const isOpen = useSelector(({nav}) => nav.open);
    const isAuth = useSelector(({auth}) => auth.isAuth);
    const {pathname, search} = useLocation();
    const isMobile = useMobile();
    const history = useHistory();
    const [cookies] = useCookies();
    const { windowHeight } = useWindowSize();
    const { removeCookies } = useAuthCookies();
    const [billing, setBilling] = useState("DEFAULT");
    const bannerHeight = useSelector(({ nav }) => nav.bannerHeight);

    useEffect(() => {
        dispatch(getUserSettings()).then(res => {
            setBilling(res.data.settings.shop.payout_billing_method);
        });
    }, []);

    const setup = useSelector(({auth}) => (auth.shop || {}).setup_wizard);

    useEffect(() => {
        if (!!setup) {
            history.push('/setup');
        }
    }, [!!setup]);

    useEffect(() => {

        if (isMobile) {
            dispatch(toggleNav(false));
        } else {
            dispatch(toggleNav(Number(localStorage.getItem('nav'))));
        }

        if (search) {
            let params = new URLSearchParams(search);
            let shop_id = params.get('shop_id');

            if (shop_id) {
                dispatch(changeShops(shop_id, pathname));
            }
        }

        if (cookies.subscription) {

            let data = {
                gateway: cookies.subscription_gateway,
                coupon_code: "",
                months: cookies.subscription_month,
                subscription_id: cookies.subscription,
                currency: "EUR"
            };

            dispatch(createSubscriptionInvoice(data))
                .then(({data, status, message}) => {

                    if (status === 200) {
                        removeCookies('subscription');
                        removeCookies('subscription_month');
                        removeCookies('subscription_gateway');
                        redirectToSubLink('checkout', `/invoice/${data.invoice.uniqid}`, history);
                    }

                    if (status !== 401 && status !== 200) {
                        removeCookies('subscription');
                        removeCookies('subscription_month');
                        removeCookies('subscription_gateway');
                        throw {message};
                    }

                })
                .catch(err => {
                    removeCookies('subscription');
                    removeCookies('subscription_month');
                    removeCookies('subscription_gateway');
                    toastAlert('error', err.error || err.message);
                });
        }
    }, []);

    useEffect(() => {
        if (pathname === '/referrals') {
            history.push(`/share-and-earn`);
        }
    }, [pathname]);


    return (
        <GoogleReCaptchaProvider reCaptchaKey={config.CAPTCHA_SITE_KEY_V3}>
            <ErrorBoundary>
                <div className="app">

                    <Header changeTheme={changeTheme} isDashboard />

                    <div className="app-body" style={{ height: `calc(${windowHeight}px - ${bannerHeight}px - 3.5rem)` }}>
                        {isMobile ? null : <Sidebar billing={billing}/>}
                        <MobileMenu changeTheme={changeTheme}/>

                        <main className={`main ${isOpen ? '' : 'minimized'}`}>
                            <div className="container">
                                {isAuth ? <>
                                    <Switch>
                                        <Route path="/" exact={true}>
                                            <MetaData isDashboard meta={{title: "Dashboard"}}><Dashboard/></MetaData>
                                        </Route>
                                        {dashboardRoutes.map(({path, metadata, component: Component}, key) => (
                                            <Route path={path} key={key}>
                                                <MetaData isDashboard meta={metadata}><Component/></MetaData>
                                            </Route>
                                        ))}
                                        <Route path="*">
                                            <NotFound isDashboard />
                                        </Route>
                                    </Switch>
                                </> : null}
                            </div>
                        </main>
                    </div>
                </div>
            </ErrorBoundary>
        </GoogleReCaptchaProvider>
    );
}

export default layoutHOC(DashboardLayout);

